// extracted by mini-css-extract-plugin
module.exports = {"embed":"Embed_embed__pNGnu","placeholder":"Embed_placeholder__uwfgh"};